import React, { useEffect, useState, useRef } from "react";

const HOTEL_REVIEW_API = "http://localhost:50574/api/hotel/Review";

export default function HotelDetail() {
  const [reviewData, setReviewData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    fetchHotelReview();
  }, []);

  const fetchHotelReview = async () => {
    setLoading(true);
    setError(null);

    let searchResponse = null;
    let selectedHotel = null;

    try {
      searchResponse = JSON.parse(sessionStorage.getItem("hotelSearchResponse") || "null");
    } catch (err) {
      console.error("Could not parse hotel search response", err);
    }

    try {
      selectedHotel = JSON.parse(sessionStorage.getItem("selectedHotel") || "null");
    } catch (err) {
      console.error("Could not parse selected hotel", err);
    }

    if (!searchResponse || !selectedHotel) {
      setError("Hotel search data not found. Please go back and search again.");
      setLoading(false);
      return;
    }

    const bestRoom =
      Array.isArray(selectedHotel.TripRooms) && selectedHotel.TripRooms.length > 0
        ? selectedHotel.TripRooms[0]
        : null;

    const payload = {
      HotelId: String(selectedHotel.TripId || selectedHotel.HotelId || ""),
      optionId: String(bestRoom?.optionsId || bestRoom?.BookHash || ""),
      HotelSearchres: searchResponse, // poora search response as-is
    };

    console.log("Hotel review URL:", HOTEL_REVIEW_API);
    console.log("Hotel review request payload:", payload);

    try {
      const res = await fetch(HOTEL_REVIEW_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errBody = await res.text();
        throw new Error(`Request failed with status ${res.status}: ${errBody}`);
      }

      const data = await res.json();
      console.log("Hotel review response:", data);
      setReviewData(data);
    } catch (err) {
      console.error("Hotel review request failed:", err);
      setError(err.message || "Something went wrong while fetching hotel review.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading hotel review…</div>;
  if (error) return <div style={{ color: "#dc2626", fontWeight: 600 }}>{error}</div>;

  return (
    <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
      <h2>Hotel Review Response</h2>
      {reviewData ? (
        <pre
          style={{
            background: "#f3f4f6",
            padding: "16px",
            borderRadius: "8px",
            overflowX: "auto",
            fontSize: "13px",
            lineHeight: "1.5",
          }}
        >
          {JSON.stringify(reviewData, null, 2)}
        </pre>
      ) : (
        <div>No data received.</div>
      )}
    </div>
  );
}